import { appSyncApolloClient } from './api';
import gql from 'graphql-tag';

export async function initSupportUser(userId, orgId, orgs = []) {
  const alreadyInOrg = !!orgs.find(org => org.orgId === orgId);
  if (alreadyInOrg) return;

  try {
    const resp = await appSyncApolloClient.mutate({
      variables: {
        orgId,
        userId: `user-${userId}`,
        displayData: {
          name: 'System Admin',
          email: `system+user-${userId}@qsrsoft.com`,
        },
        supportUser: true,
      },
      mutation: gql`
        mutation addUserToOrg(
          $orgId: String!
          $userId: String!
          $displayData: DisplayDataInput!
          $supportUser: Boolean
        ) {
          addUserToOrg(
            orgId: $orgId
            userId: $userId
            displayData: $displayData
            supportUser: $supportUser
          ) {
            orgId
            userId
            addedByUserId
            orgAdmin
            displayData {
              name
              email
            }
          }
        }
      `,
    });
    // console.log('supportUser.js : user added org to org');
    return true;
  } catch (err) {
    console.error('supportUser.js : failed to add user to org', err);
  }
}

// Remove user from all other orgs where they are support if they are
// a supportUser on 5+ orgs. Does not affect non-support orgs.
export async function clearSupportUser(userId, orgs, orgId) {
  if (!userId || !orgs) return;

  const supportOrgs = orgs.filter(org => org.supportUser && org.orgId !== orgId);
  if (supportOrgs.length >= 5) {
    // console.log('removing orgs, you are in too many orgs');
    const removalPromises = supportOrgs.map(org => {
      return appSyncApolloClient.mutate({
        variables: {
          orgId: org.orgId,
          userId: `user-${userId}`,
        },
        mutation: gql`
          mutation removeUserFromOrg($userId: String!, $orgId: String!) {
            removeUserFromOrg(userId: $userId, orgId: $orgId)
          }
        `,
      });
    });

    await Promise.all(removalPromises);
    // wait 1 sec for sso to do its thing
    if (removalPromises.length) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    return true;
  }
  return true;
}
